import {
    GET_HELP,
    GET_HELP_SUCCESS,
    GET_HELP_FAILURE,
    UPDATE_HELP_STATUS,
    UPDATE_HELP_STATUS_SUCCESS,
    UPDATE_HELP_STATUS_FAILURE,
    ADD_HELP,
    ADD_HELP_SUCCESS,
    ADD_HELP_FAILURE,
    EDIT_HELP,
    EDIT_HELP_SUCCESS,
    EDIT_HELP_FAILURE,
    DELETE_HELP,
    DELETE_HELP_SUCCESS,
    DELETE_HELP_FAILURE,
    GET_HELP_DETAILS,
    GET_HELP_DETAILS_SUCCESS,
    GET_HELP_DETAILS_FAILURE,
    QUESTION_DROPDOWN_LIST,
    QUESTION_DROPDOWN_LIST_SUCCESS,
    QUESTION_DROPDOWN_LIST_FAILURE,
    UPDATE_HELP_ORDER_STATUS,
    UPDATE_HELP_ORDER_STATUS_SUCCESS,
    UPDATE_HELP_ORDER_STATUS_FAILURE,
} from "../Constants"

export const GetHelp = (payload) => ({
    type: GET_HELP,
    payload
});

export const GetHelpSuccess = (payload) => ({
    type: GET_HELP_SUCCESS,
    payload
});

export const GetHelpFailure = (payload) => ({
    type: GET_HELP_FAILURE,
    payload
});

export const UpdateHelpStatus = (payload) => ({
    type: UPDATE_HELP_STATUS,
    payload
});

export const UpdateHelpStatusSuccess = (payload) => ({
    type: UPDATE_HELP_STATUS_SUCCESS,
    payload
});

export const UpdateHelpStatusFailure = (payload) => ({
    type: UPDATE_HELP_STATUS_FAILURE,
    payload
});

export const AddHelp = (payload) => ({
    type: ADD_HELP,
    payload
});

export const AddHelpSuccess = (payload) => ({
    type: ADD_HELP_SUCCESS,
    payload
});

export const AddHelpFailure = (payload) => ({
    type: ADD_HELP_FAILURE,
    payload
});

export const EditHelp = (payload) => ({
    type: EDIT_HELP,
    payload
});

export const EditHelpSuccess = (payload) => ({
    type: EDIT_HELP_SUCCESS,
    payload
});

export const EditHelpFailure = (payload) => ({
    type: EDIT_HELP_FAILURE,
    payload
});

export const DeleteHelp = (payload) => ({
    type: DELETE_HELP,
    payload
});

export const DeleteHelpSuccess = (payload) => ({
    type: DELETE_HELP_SUCCESS,
    payload
});

export const DeleteHelpFailure = (payload) => ({
    type: DELETE_HELP_FAILURE,
    payload
});

export const GetHelpDetails = (payload) => ({
    type: GET_HELP_DETAILS,
    payload
});

export const GetHelpDetailsSuccess = (payload) => ({
    type: GET_HELP_DETAILS_SUCCESS,
    payload
});

export const GetHelpDetailsFailure = (payload) => ({
    type: GET_HELP_DETAILS_FAILURE,
    payload
});

export const QuestionDropdownList = () => ({
    type: QUESTION_DROPDOWN_LIST
});

export const QuestionDropdownListSuccess = (payload) => ({
    type: QUESTION_DROPDOWN_LIST_SUCCESS,
    payload
});

export const QuestionDropdownListFailure = (payload) => ({
    type: QUESTION_DROPDOWN_LIST_FAILURE,
    payload
});

export const UpdateHelpOrderStatus = (payload) => ({
    type: UPDATE_HELP_ORDER_STATUS,
    payload
});

export const UpdateHelpOrderStatusSuccess = (payload) => ({
    type: UPDATE_HELP_ORDER_STATUS_SUCCESS,
    payload
});

export const UpdateHelpOrderStatusFailure = (payload) => ({
    type: UPDATE_HELP_ORDER_STATUS_FAILURE,
    payload
});